import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Box, styled } from '@mui/material';
import { TChangePasswordFormData } from 'src/@types';
import FormProvider, { RHFTextField } from 'src/components/hook-form';
import { ContentButtonCreate } from 'src/layouts/form/FormButton';
import { FormInnerContainer, FormItem, FormLabel, FormRow } from 'src/layouts/form/FormLayout';
import { useStores } from 'src/models';
import { useHandleResponse } from 'src/service/useHandleResponse';
import { FORM_IDS } from 'src/static/constants/common/form';
import changePwdFormValidationSchema from 'src/static/yup/changePwdFormValidationSchema';

import { useDialogContext } from '../dialog/DialogContext';

/**
 * ## MyInfoModalModal 설명
 * - 내 정보 모달
 * - 프로필 이미지 업로드, 기본정보, 비밀번호 변경
 */

function MyInfoModalModal() {
  const { authStore } = useStores();
  const handleResponse = useHandleResponse();
  const { closeDialog } = useDialogContext();
  const resolver = yupResolver(changePwdFormValidationSchema);
  const methods = useForm<any>({
    mode: 'all',
    resolver,
    defaultValues: {
      oprtrNm: authStore.user?.oprtrNm,
      loginId: authStore.user?.loginId,
    },
  });

  const {
    handleSubmit,
    formState: { errors },
  } = methods;

  const onSubmit = async (data: TChangePasswordFormData) => {
    const result = await authStore.changePassword(data);
    if (result) {
      handleResponse(`비밀번호 변경이 완료되었습니다.`, `비밀번호 변경이 실패되었습니다.`, () =>
        closeDialog(FORM_IDS.MYINFO),
      );
    }
  };
  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)} formId={FORM_IDS.MYINFO}>
      <FormInnerContainer>
        <FormLabel>기본 직원 정보</FormLabel>
        <FormRow sx={{ gridTemplateColumns: '1fr 1fr' }}>
          <FormItem>
            <RHFTextField label="이름" name="oprtrNm" readonly={true} />
          </FormItem>
          <FormItem>
            <RHFTextField label="로그인 ID" name="loginId" readonly={true} />
          </FormItem>
        </FormRow>
      </FormInnerContainer>

      <FormInnerContainer>
        <FormLabel>비밀번호 변경</FormLabel>
        <FormRow sx={{ gridTemplateColumns: '1fr' }}>
          <FormItem>
            <RHFTextField label="현재 비밀번호" name="currentPwd" type="password" />
          </FormItem>
        </FormRow>
        <FormRow sx={{ gridTemplateColumns: '1fr' }}>
          <FormItem>
            <RHFTextField label="변경할 비밀번호" name="pwd" type="password" />
          </FormItem>
        </FormRow>
        <FormRow sx={{ gridTemplateColumns: '1fr' }}>
          <FormItem>
            <RHFTextField label="변경할 비밀번호 확인" name="pwdCorrect" type="password" />
          </FormItem>
        </FormRow>
        <ChangePwdBtnContainer>
          <ContentButtonCreate type="submit">변경</ContentButtonCreate>
        </ChangePwdBtnContainer>
      </FormInnerContainer>
    </FormProvider>
  );
}

export default MyInfoModalModal;

const ChangePwdBtnContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: theme.spacing(1),
}));
